export default function Cart() {
    return (
        <svg className="shopping-cart-icon" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="24" cy="24" r="24" fill="white" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.7266 17.5996H32.4342C33.2992 17.5996 34.0004 18.3008 34.0004 19.1658C34.0004 19.3139 33.9795 19.4611 33.9381 19.6033L31.4322 28.2174C31.2376 28.8862 30.6248 29.3461 29.9283 29.3461H20.3192C19.6227 29.3461 19.0099 28.8862 18.8154 28.2174L15.7266 17.5996Z"
                stroke="#3F68E0"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M16.1986 19.1655L15.3203 16.3498C15.1162 15.6956 14.5105 15.25 13.8251 15.25H11.5"
                stroke="#3F68E0"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M20.25 34C20.9404 34 21.5 33.4404 21.5 32.75C21.5 32.0596 20.9404 31.5 20.25 31.5C19.5596 31.5 19 32.0596 19 32.75C19 33.4404 19.5596 34 20.25 34Z"
                fill="#3F68E0"
            />
            <path
                d="M30.25 34C30.9404 34 31.5 33.4404 31.5 32.75C31.5 32.0596 30.9404 31.5 30.25 31.5C29.5596 31.5 29 32.0596 29 32.75C29 33.4404 29.5596 34 30.25 34Z"
                fill="#3F68E0"
            />
            <path d="M21.9922 21.5293V25.4478" stroke="#3F68E0" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M25.125 21.5293V25.4478" stroke="#3F68E0" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M28.2578 21.5293V25.4478" stroke="#3F68E0" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    );
}
